import { render, staticRenderFns } from "./market.vue?vue&type=template&id=c46b58a2&scoped=true&"
import script from "./market.js?vue&type=script&lang=js&"
export * from "./market.js?vue&type=script&lang=js&"
import style0 from "./market.css?vue&type=style&index=0&id=c46b58a2&scoped=true&lang=css&"
import style1 from "./market_spinner.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46b58a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
